import type { SVGProps } from 'react'
const SvgSyInfo = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={9} fillOpacity={0.24} />
		<path d="M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 2v1c.465 0 .665.008.758.033h.002a1 1 0 0 1 .707.707v.002c.025.093.033.293.033.758V16h-1v1h3v-1h-1v-4.5c0-.465.009-.729-.068-1.018a2 2 0 0 0-1.414-1.414C10.728 8.991 10.465 9 10 9" />
	</svg>
)
export default SvgSyInfo
